<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="卡号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.cardcode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="工号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.badge">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="姓名" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.name">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="部门编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.deptcode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="人员">
                <el-button :loading="!!loading" v-authority="'BACK_MENU5_M9_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true),getDictData()">新增</el-button>
                <el-button v-authority="'BACK_MENU5_M9_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table v-loading="loading" :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="cardcode" label="卡号" />
                <el-table-column prop="badge" label="工号" />
                <el-table-column prop="name" label="姓名" />
                <el-table-column prop="title" label="职位" />
                <el-table-column prop="deptcode" label="部门编号" />
                <el-table-column prop="tel" label="联系电话" />
                <el-table-column prop="email" label="邮箱" />
                <el-table-column prop="status" label="状态" />
                <el-table-column prop="joindate" label="入职日期" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M9_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" @click="updateRow(scope.row)" plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M9_B3'" type="danger" @click="deleteRow(scope.row.badge)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainObj" @open="open" :style="$popups.popups(0.5,0.6)" class="fromDialog">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="卡号" prop="cardcode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.cardcode" maxlength="20"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="工号" prop="badge" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.badge" maxlength="50" :disabled="add_or_edit ? false : true"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="姓名" prop="name" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.name" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-form-item label="部门" prop="deptcode" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="mainObj.deptcode" placeholder="请选择" filterable clearable="clearable">
                            <el-option v-for="(item, index) in dictDataList" :key="index" :label="item.deptCode+' - '+item.deptName" :value="item.deptCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="职位" prop="title" class="EL-Form-Item">
                            <el-input v-model="mainObj.title" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="联系电话" prop="tel" class="EL-Form-Item">
                            <el-input v-model="mainObj.tel" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="邮箱" prop="email" class="EL-Form-Item">
                            <el-input v-model="mainObj.email" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="状态" prop="status" class="EL-Form-Item">
                            <el-select v-model="mainObj.status" placeholder="请选择" clearable="clearable">
                                <el-option label="实习" value="实习"></el-option>
                                <el-option label="在职" value="在职"></el-option>
                                <el-option label="离职" value="离职"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :lg="8" :xl="8">
                        <el-form-item label="入职日期" prop="joindate" class="EL-Form-Item">
                            <el-date-picker v-model="mainObj.joindate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col> -->
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "Employee",
    data() {
        return {
            headerCellStyle: () => {
                return "background-color: #1f5cec";
            },
            form: {},
            rules: {
                badge: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                name: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                deptcode: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
            },

            showRoleBox: true,
            add_or_edit: Boolean, //新增|编辑
            loading: 0, //加载中
            editBoxShow: false, //编辑框
            dialogFormVisible: false,
            formLabelWidth: "140px", // 对话框大小
            tableHeight: 0, //表格高度
            testValue: 1,
            mainObj: {},
            pagination: {
                pageSize: 50,
                pageNum: 1,
                cardcode: "",
                badge: "",
                name: "",
                deptcode: ""
            },
            tableTotal:0,
            mainData: [],
            fcode: localStorage.getItem("fcCode") || "",

            downloadLoading: false, //下载中

            dictDataList: [], //部门集合

            logContent: "", //操作日志-内容
            logRemarks: "", //操作日志-备注
            // 输入框延时加载
            isSetTimeout: null,
        };
    },
    watch: {
        pagination: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getAuxiMaterialData(newVal);
                }, 1000)
            },
            deep: true,
        },
    },
    methods: {
        //获取数据
        getAuxiMaterialData() {
            // this.loading++
            this.$http
                .request({
                    url: "/api/employee/getEmployeeData",
                    method: "GET",
                    params: {
                        pageSize: this.pagination.pageSize,
                        pageNum: this.pagination.pageNum,
                        cardcode: this.pagination.cardcode,
                        badge: this.pagination.badge,
                        name: this.pagination.name,
                        deptcode: this.pagination.deptcode
                    },
                })
                .then((resp) => {
                    // this.loading--
                    if (resp.status == 100) {
                        this.mainData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {
                    // this.loading--;
                });
        },

        updateRow(row){
            this.getDictData();
            this.chooseDictDataList = [];
            this.add_or_edit = false;
            this.editBoxShow = true;
            this.mainObj = JSON.parse(JSON.stringify(row));
            if(this.mainObj.deptcode != undefined){
                var list = this.mainObj.deptcode.split(",");
                console.log(list.length)
                console.log(list)
                for (let index = 0; index < list.length; index++) {
                    if(list[index] != '' && list[index] != undefined){
                        this.chooseDictDataList.push(list[index]);
                    }
                }
            }
            
        },

        //获取部门
        getDictData() {
            this.$http.request({
                url: "/api/tepartment/getDepartmentData",
                method: "GET",
                showLoading: true,
                params: {
                    fcCode: localStorage.getItem("fcCode") || ""
                },
            }).then((resp) => {
                if (resp.status == 100) {
                    this.dictDataList = resp.data.list || [];
                }
            }).catch((error) => {});
        },

        //表单验证
        submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    r = true;
                } else {
                    r = false;
                }
            });
            return r;
        },
        //框打开
        open() {
            if (this.add_or_edit) {
                //新增
                this.mainObj = JSON.parse(JSON.stringify({}));
            } else {
                this.getAuxiMaterialData();
            }
        },
        //新增
        add() {
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/employee/insertEmployee",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "employee：人员新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "employee：人员新增失败";
                        }
                        this.logContent = JSON.stringify(this.mainObj)
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //编辑
        editRow() {
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/employee/updateEmployee",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "employee：人员编辑成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "employee：人员编辑失败";
                        }
                        this.logContent = JSON.stringify(this.mainObj)
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //删除
        deleteRow(badge) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/employee/deleteEmployee",
                            method: "DELETE",
                            showLoading: true,
                            params: {
                                badge: badge,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.logRemarks = "employee：人员删除成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "删除失败",
                                });
                                this.logRemarks = "employee：人员删除失败";
                            }
                            this.logContent = "badge：" + badge;
                            this.systemLog();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        //重置
        resetData() {
            this.pagination = {
                pageSize: 50,
                pageNum: 1,
                mtCode: "",
                mtName: "",
                fcCode: "",
            };
            this.tableTotal=0;
            // this.getAuxiMaterialData();
        },

        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var paramsObj = {
                cardcode: this.pagination.cardcode,
                badge: this.pagination.badge,
                name: this.pagination.name,
                deptcode: this.pagination.deptcode,
                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/employee/getEmployeeData',
                method: 'GET',
                showLoading: true,
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                const tHeader = ['卡号', '工号', '姓名', '职位', '部门编号', '联系电话', '邮箱', '状态', '入职日期']
                const filterVal = ['cardcode', 'badge', 'name', 'title', 'deptcode', 'tel', 'email', 'status', 'joindate']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '人员数据'
                })
                this.logContent = "导出"
                this.logRemarks = "sys_employee：导出人员数据"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },


        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "物料主数据",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated(){
        /* 获取首页的数据 */
        this.getAuxiMaterialData();
    },
};
</script>

<style scoped>
</style>